import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-delete-button',
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.scss'],
  imports: [TranslateModule, MatMenuItem, MatIconButton, MatTooltip],
})
export class DeleteButtonComponent {
  @Input() isMenu = false;

  constructor() {}
}
